<template>
  <div :class="classes" v-bind="$attrs" v-on="$listeners">
    <!-- @slot Card content -->
    <slot />
  </div>
</template>

<script>
import { enumValidator } from "../enumValidator";

export default {
  inheritAttrs: false,
  props: {
    /**
     * Adds background color [0, 1, 2]
     */
    overlay: {
      type: Number,
      validator: enumValidator([0, 1, 2]),
      default: 0
    },
    /**
     * Removes the shadow and displays a hairline outline instead.
     */
    outlined: {
      type: Boolean,
      default: false
    },
    /**
     * Sets the elevation
     */
    elevation: {
      type: Number,
      default: 4,
      validator: value => value >= 0 && value <= 24
    },
    /**
     * Removes border radius
     */
    square: {
      type: Boolean,
      default: false
    },
    /**
     * Removes border radius
     */
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        "am-card",
        "mdc-card",
        {
          "am-card--square": this.square,
          "am-card--inline": this.inline,
          "am-card--no-elevation": !this.elevation,
          "mdc-card--outlined": this.outlined,
          [`am-card--overlay-${this.overlay}`]: this.overlay,
          [`mdc-elevation--z${this.elevation}`]: true
        }
      ];
    }
  }
};
</script>
